import Spinner from '@components/ui/spinner/spinner';
export default Spinner;
